// Wallex brand colors. `primary` is a darker teal so white text on buttons stays readable (WCAG AA)
export const brand = {
    primary: '#00796B',
    teal: '#09C7AD',
    tealDark: '#03AC95',
    navy: '#093454',
}
